import styled from "styled-components";

interface ITopbarSidebarMenuContainerProps {
  sideMenuIsOpen: boolean;
}

export const TopbarSidebarMenuContainer = styled.button<ITopbarSidebarMenuContainerProps>`
  background: transparent;
  border: none;

  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  gap: 4px;

  font: 500 1.125rem/1.6875rem "Inter" !important;
  color: ${({ theme }) => theme.colors.globalTopbar.menuItensColor};

  @media (max-width: 1600px) {
    font: 500 0.875rem/1.3125rem "Inter" !important;
  }

  padding: 0.38rem 0.75rem;
  display: block;

  border-radius: 4px;

  transition: 0.3s all;

  :hover {
    cursor: pointer;
  }
`;
